<!-- @format -->

<h3>{{ "FILE_UPLOAD.FILE_TITLE" | translate }}</h3>
@if (!(attachments?.length > 0) && currentExternalAttachments.length === 0) {
  <span class="guidance">{{ "FILE_UPLOAD.ZERO_FILES" | translate }}</span>
}
<sis-emrex-attachments [showLink]="false" [externalAttainedStudyAttachments]="externalAttainedStudyAttachments"></sis-emrex-attachments>
@for (attachment of attachments; track attachment) {
  <div class="file-preview">
    <span class="file-name">{{ attachment.file.name }} ({{ readableFileSizeString(attachment.file.size) }})</span>
    <p class="file-comment">{{ attachment.explanation }}</p>
  </div>
}
